import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as userActions from 'core/duck';
import { Input } from 'shared/components';
import { ValidationService, UsersService } from 'shared/services';
import './PasswordReset.scss';

class PasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      errors: {},
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.user && prevProps.user !== this.props.user) {
      this.setState({
        user: this.props.user,
        validEmail: true,
      });
    } else if (!this.props.user && prevProps.user !== this.props.user) {
      this.setState({
        errors: {
          email: ['errors.emailDoesNotExist'],
        },
      });
    }
  }

  onChange(e) {
    this.setState({
      email: e.target.value,
      errors: {},
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const { email } = this.state;

    if (!email) {
      this.setState({
        errors: {
          email: ['errors.emailRequired'],
        },
      });
      return;
    }
    const isValidEmail = ValidationService.validEmail(email);
    if (isValidEmail) {
      UsersService.checkUsername(this.state.email)
        .then((response) => {
          if (!response.result) {
            this.setState({
              errors: {
                email: ['errors.emailDoesNotExist'],
              },
            });
            return;
          }
          UsersService.forgotPassword(this.state.email)
            .then(() => {
              this.props.onSubmit(this.state.email);
            })
            .catch((error) => {
              this.setState({
                errors: {
                  email: [error.data.Error],
                },
              });
            });
        })
        .catch(() => {
          this.setState({
            errors: {
              email: ['errors.somethingWentWrong'],
            },
          });
        });
    } else {
      this.setState({
        errors: {
          email: ['errors.emailInvalid'],
        },
      });
    }
  }

  render() {
    const { errors } = this.state;
    return (
      <form className="reset-pasword-form" onSubmit={this.onSubmit} noValidate>
        <h4>{this.props.t('resetPassword.resetPasswordTitle')}</h4>
        <p>{this.props.t('resetPassword.resetPasswordCopy')}</p>
        <Input
          size="w-100"
          type="email"
          name="email"
          value={this.state.email}
          label="common.labels.email"
          onChange={this.onChange}
          errors={errors.email}
          required
        />
        <button type="submit" className="btn btn-primary w-100 m-0">
          {this.props.t('login.confirmEmail')}
        </button>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(userActions, dispatch) };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PasswordReset));

PasswordReset.propTypes = {
  user: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

PasswordReset.defaultProps = {
  user: {},
};
